import { Mic, MicOff } from "lucide-react";
import { useEffect } from "react";
import styles from "./TutorLiveScreen.module.css";

const Toolbar = ({
  isStarted,
  isMuted,
  isMicLoading,
  isRTCStarted,
  isSendingQuestion,
  joinCall,
  leaveCall,
  setMicMuted,
  setIsSendingQuestion,
}: {
  isStarted: boolean | null;
  isMuted: boolean | null;
  isMicLoading: boolean;
  isRTCStarted: boolean;
  isSendingQuestion: boolean;
  joinCall: () => void;
  leaveCall: () => void;
  setMicMuted: () => void;
  setIsSendingQuestion: (value: boolean) => void;
}) => {
  // const [cameraOpened, setCameraOpened] = useState(false);

  useEffect(() => {
    if (!isStarted) return;
    joinCall();

    return () => {
      leaveCall();
    };
  }, [joinCall]);

  return (
    <div className={styles.toolbar}>
      <button
        className={
          !isMuted
            ? isMicLoading || !isRTCStarted
              ? styles.disabled
              : styles.active
            : ""
        }
        onClick={() => setMicMuted()}
        disabled={isMicLoading}
      >
        {!isMuted ? (
          <Mic className="text-white" />
        ) : (
          <MicOff className="text-primary" />
        )}
      </button>
      {/* <button
        className={`${cameraOpened ? styles.active : ""}`}
        onClick={() => setCameraOpened(!cameraOpened)}
      >
        {cameraOpened ? (
          <img src={CAMERA_OPEN} alt="الكاميرا مفتوحة" />
        ) : (
          <img src={CAMERA_CLOSED} alt="الكاميرا مغلقة" />
        )}
      </button> */}
      <button
        className={`${isSendingQuestion ? styles.active : ""}`}
        onClick={() => setIsSendingQuestion(!isSendingQuestion)}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="32"
          height="32"
          fill={isSendingQuestion ? "white" : "#1c4d57"}
          className="bi bi-question"
          viewBox="0 0 16 16"
        >
          <path d="M5.255 5.786a.237.237 0 0 0 .241.247h.825c.138 0 .248-.113.266-.25.09-.656.54-1.134 1.342-1.134.686 0 1.314.343 1.314 1.168 0 .635-.374.927-.965 1.371-.673.489-1.206 1.06-1.168 1.987l.003.217a.25.25 0 0 0 .25.246h.811a.25.25 0 0 0 .25-.25v-.105c0-.718.273-.927 1.01-1.486.609-.463 1.244-.977 1.244-2.056 0-1.511-1.276-2.241-2.673-2.241-1.267 0-2.655.59-2.75 2.286m1.557 5.763c0 .533.425.927 1.01.927.609 0 1.028-.394 1.028-.927 0-.552-.42-.94-1.029-.94-.584 0-1.009.388-1.009.94" />
        </svg>
      </button>
    </div>
  );
};

export default Toolbar;
